import React from 'react';
import { useSession } from '../../context/SessionContext';
import { t } from '../../services/sessionManager';

export const CookieBanner: React.FC = () => {
  const { user, language, acceptCookies, isLoading } = useSession();

  // If loading or consent is already given, don't show anything
  if (isLoading || !user || user.cookieConsent) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 md:bottom-8 md:left-8 md:right-auto z-[100] p-4 md:p-0">
      <div className="bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-[32px] p-8 shadow-2xl max-w-sm animate-in slide-in-from-bottom-8 duration-500">
        <h2 className="font-black uppercase tracking-tighter text-2xl mb-4">
          {t('cookieTitle', language)}
        </h2>
        <p className="text-sm leading-relaxed mb-8 opacity-90">
          {t('cookieContent', language)}
        </p>
        <button
          onClick={() => acceptCookies()}
          className="bg-[#D90168] text-white px-8 py-4 rounded-2xl font-black uppercase text-xs w-full transition-colors active:bg-[#b00155]"
        >
          {t('cookieButton', language)}
        </button>
      </div>
    </div>
  );
};